import { getPath } from '~/src/common/components/Navigation/utils';
import Tracker from '~/src/common/services/Tracker';

import { useCategoryMenu } from '../use-category-menu';

import * as S from './layout';
import Classic from './MenuClassic';
import Loading from './MenuLoading';
import Recipes from './MenuRecipes';
import Unknown from './MenuUnknown';

interface Props {
  slug: string;
}

const CategoryMenu = ({ slug }: Props) => {
  const { mode, navigation, isActiveID } = useCategoryMenu(slug);

  // Cas spécial si le menu est indéterminé. Exclure ce cas en
  // amont permet d'assurer l'existence des autres variables.
  if (mode == null) {
    return (
      <S.Container>
        <Loading />
      </S.Container>
    );
  }

  // Le menu à utiliser en fonction du mode
  const Menu = {
    classic: Classic,
    recipes: Recipes,
    unknown: Unknown,
  }[mode];

  // Les props à passer au menu
  const menuProps = {
    navigation,
    isActiveID,
    onLinkClick: (itemID: string) => {
      const path = getPath(navigation, itemID);
      if (path == null || navigation == null) return;
      Tracker.sendEvent('user navigation menu category', {
        source: 'Treeview',
        ...('family' in path && {
          'family name': path.family.item.name,
          'family position': path.family.index + 1,
          'number of categories': path.family.item.categories.length,
          'navigation text': path.family.item.name,
        }),
        ...('category' in path && {
          'category name': path.category.item.name,
          'category position': path.category.index + 1,
          'number of subcategories': path.category.item.children.length,
          'navigation text': path.category.item.name,
        }),
        ...('subcategory' in path && {
          'subcategory name': path.subcategory.item.name,
          'subcategory position': path.subcategory.index + 1,
          'navigation text': path.subcategory.item.name,
        }),
        ...('recipecategory' in path && {
          'category name': path.recipecategory.item.name,
          'number of subcategories': path.recipecategory.item.children.length,
          'navigation text': path.recipecategory.item.name,
        }),
        ...('recipesubcategory' in path && {
          'subcategory name': path.recipesubcategory.item.name,
          'subcategory position': path.recipesubcategory.index + 1,
          'navigation text': path.recipesubcategory.item.name,
        }),
      });
    },
  };

  if (Menu == null) return null;

  return (
    <S.Container data-menu-mode={mode}>
      <Menu {...menuProps} />
    </S.Container>
  );
};

export default CategoryMenu;
